import * as ACTIONS from "./types"

export const selectDevice = deviceID => ({
  type: ACTIONS.SELECT_DEVICE,
  payload: deviceID
})

export const selectPlan = planID => ({
  type: ACTIONS.SELECT_PLAN,
  payload: planID
})

export const addExtra = extraID => ({
  type: ACTIONS.ADD_EXTRA,
  payload: extraID
})

export const removeExtra = extraID => ({
  type: ACTIONS.REMOVE_EXTRA,
  payload: extraID
})

export const addEntertainment = (entertainmentCost, planID) => ({
  type: ACTIONS.ADD_ENTERTAINMENT,
  payload: {
    entertainmentCost,
    planID
  }
})

export const builtPlan = (upfront, duration, data, cost) => ({
  type: ACTIONS.BUILT_PLAN,
  payload: {
    upfront,
    duration,
    data,
    cost
  }
})

export const addBenefit = benefitID => ({
  type: ACTIONS.ADD_BENEFIT,
  payload: benefitID
})

export const removeBenefit = benefitID => ({
  type: ACTIONS.REMOVE_BENEFIT,
  payload: benefitID
})

export const setAllPlansButtonClicked = wasClicked => ({
  type: ACTIONS.ALL_PLANS_BUTTON_CLICKED,
  payload: wasClicked
})

export const resetBasket = () => ({
  type: ACTIONS.RESET_BASKET
})
